import { useCallback } from 'react';
import PropTypes from 'prop-types';

import Pill from '@gef-ui/components/atoms/Pill';

const FileGroup = ({ files = [], disabled = false, onRemoveFile }) => {
	const handleRemoveFile = useCallback(
		(file) => () => {
			!disabled && onRemoveFile && onRemoveFile(file);
		},
		[disabled, onRemoveFile],
	);

	return (
		<div className={disabled ? 'FileGroup--disabled' : ''}>
			{files.map((file, i) => {
				return (
					<Pill key={i} onClick={handleRemoveFile(file)} className="FileGroup__pill">
						{file.name}
					</Pill>
				);
			})}
		</div>
	);
};

FileGroup.propTypes = {
	disabled: PropTypes.bool,
	files: PropTypes.array,
	onRemoveFile: PropTypes.func,
};

export default FileGroup;
